import Hls from 'hls.js';

export default ({app}, inject) => {
  let hls = null;

  inject('hls', {
    create() {
      hls = new Hls({
        manifestLoadingTimeOut: 3000,
        manifestLoadingMaxRetry: 4,
        manifestLoadingRetryDelay: 1000,
        fragLoadingTimeOut: 3000,
        fragLoadingMaxRetry: 4,
        fragLoadingRetryDelay: 1000,
      });

      hls.on(Hls.Events.ERROR, (event, data) => {
        if (data.fatal) {
          switch (data.fatal) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              console.error('A network error occurred:', data);

              // Try to reconnect
              hls.startLoad();
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              console.error('A media error occurred:', data);

              // Try to recover from the error
              hls.recoverMediaError();
              break;
            default:
              console.error('An unknown error occurred:', data);

              // Unrecoverable error. Destroy the HLS instance
              this.destroy();
              break;
          }
        }
      });

      return hls;
    },
    getHls() {
      return hls;
    },
    destroy() {
      hls.detachMedia();
      hls.destroy();

      hls = null;
    },
  });
};
